import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import { Icon,Loader } from "semantic-ui-react";
import Language from "./Language";
import { Message } from "semantic-ui-react";
import InnerlogicLogo from "assets/images/Logo blue.png";

import { CSSTransition, TransitionGroup } from "react-transition-group"; // new
import LogoAnimation from "survey/SurveyComponents/LogoAnimations";
import { currentApi, staginApi } from "_config";

import {
  SG_ADD_EMPLOYEE_TO_DEBRIEF_SURVEY,
  SG_DEBRIEF_SURVEY,
  SG_VERIFY_EMPLOYEE_SURVEY,
  CLEAR_DEBRIEF_SURVEY,
} from "constants/actions";
import { get } from "http";

const SurveyStart = ({ title }) => {
  const dispatch = useDispatch();
  let { token } = useParams();


  const [debriefSurvey, setDebriefSurvey] = useState(false);
  const [direction, setDirection] = useState("slide");
  const [isVisible, setIsVisible] = useState(true);
  const [submitError, setSubmitError] = useState(false);
  const [language, setLanguage] = useState("EN");

  const [loading, setLoading] = useState(true);

  const [email, setEmail] = useState("");

  const [formErrors, setFormErrors] = useState([]);
  const [pristine, setPristine] = useState(true);

  const [surveyCreated, setSurveyCreated] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("EN");
  const [isMobile, setIsMobile] = useState(false);
  const [fetchedSurveyUrl, setFetchedSurveyUrl] = useState(null);

  const { get_debrief_survey, get_errors, verify_response, verify_pending } = useSelector(
    (state) => ({
      get_debrief_survey: state.debrief_survey,
      get_errors: state.errors,
      verify_response: state.debrief_survey.verify_response,
      verify_pending: state.debrief_survey.verify_pending,
    }),
    shallowEqual
  );

  let [searchParams, setSearchParams] = useSearchParams();
  const direct_language = Number(searchParams.get("language"));
  console.log(get_debrief_survey)
 
  useEffect(() => {
    if (direct_language === 1) {
      setLanguage('FR');
    }

  }, [direct_language]);

  // Detect mobile device / viewport
  useEffect(() => {
    const detect = () => {
      if (typeof window === 'undefined') return;
      const ua = navigator.userAgent || '';
      const byUA = /(Mobi|Android|iPhone|iPad|iPod)/i.test(ua);
      const bySize = window.innerWidth <= 768;
      setIsMobile(byUA || bySize);
    };
    detect();
    window.addEventListener('resize', detect);
    return () => window.removeEventListener('resize', detect);
  }, []);

  useEffect(() => {
    if (get_debrief_survey?.debrief_survey) {
      setDebriefSurvey(get_debrief_survey?.debrief_survey);
    }
  }, [get_debrief_survey.debrief_survey]);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 400);
  }, []);

  useEffect(() => {
    if (get_debrief_survey?.employee_added) {
        setSurveyCreated(get_debrief_survey?.employee_added);
        setFormErrors({submitted: {error: false, message: 'already submitted, reset the form'}, errors: 1});
      }
  }, [get_debrief_survey.employee_added]);

  // Handle verify response
  useEffect(() => {
    if (verify_response) {
      console.log('verify_response:', verify_response);
      
      // Check if response indicates survey already completed
      if (verify_response.status_code === 403 && verify_response.already_completed) {
        // Show completion message instead of opening survey
        setFormErrors({
          email: {
            error: true,
            message: language === 'EN' 
              ? 'This survey for this associate ID has been completed.'
              : 'Ce sondage pour cet identifiant d\'associé a été complété.',
          },
          errors: 1
        });
        // Clear any pending link state on mobile
        if (isMobile) {
          setFetchedSurveyUrl(null);
        }
        return;
      }
      
      // Clear the employee ID input and reset form state
      if (!isMobile) {
        // For desktop, we open immediately and reset form
        setEmail('');
        setPristine(true);
        setFormErrors({});
      }
      
      // Build survey URL based on environment
      const baseUrl = currentApi === staginApi 
        ? 'https://stg-survey.innerlogic.com' 
        : 'https://survey.innerlogic.com';
      
      let surveyUrl = `${baseUrl}/culture-audit-v2/${verify_response.token}`;
      
      // Append language parameter if French was selected
      if (selectedLanguage === 'FR') {
        surveyUrl += '?language=1';
      }
      
      if (isMobile) {
        // On mobile, store the URL and show the second button to open it
        setFetchedSurveyUrl(surveyUrl);
      } else {
        // Desktop: open survey in new tab immediately
        window.open(surveyUrl, '_blank');
      }
    }
  }, [verify_response, selectedLanguage, language, isMobile]);

  // Handle verify errors
  useEffect(() => {
    if (get_errors?.errors && !pristine && verify_pending === false && verify_response === null) {
      console.log('Error handler triggered:', { get_errors, verify_response, verify_pending, pristine });
      
      // Check if this is a 500 error with 403 status_code in response body (survey completed)
      const errorData = get_errors.errors.data;
      if (errorData && errorData.status_code === 403 && errorData.already_completed) {
        setFormErrors({
          email: {
            error: true,
            message: language === 'EN' 
              ? 'This survey for this associate ID has been completed.'
              : 'Ce sondage pour cet identifiant d\'associé a été complété.',
          },
          errors: 1
        });
        setFetchedSurveyUrl(null);
        return;
      }
      
      // Show generic error message based on selected language
      const errorMsg = language === 'EN' 
        ? 'Unable to verify the employee ID. Please try again or contact support.'
        : 'Impossible de vérifier l\'identifiant de l\'employé. Veuillez réessayer ou contacter le support.';
      
      setFormErrors({
        email: {
          error: true,
          message: errorMsg,
        },
        errors: 1
      });
      setFetchedSurveyUrl(null);
    }
  }, [get_errors, verify_response, verify_pending, language, pristine]);

  useEffect(() => {
   setLanguage(direct_language === 1 ? "FR" : "EN");
  }, [direct_language]);


  useEffect(() => {
    if (token) {
      dispatch({
        type: SG_DEBRIEF_SURVEY,
        payload: token,
      });
    }
  }, [dispatch, token]);


  function handleSubmit() {
    setPristine(false);
    
    if (email?.length !== 7 || !ValidateAssociateID(email)) {
      return;
    }

    // Create email by appending domain to employee ID
    // Use employee_id_domain from debrief survey data, fallback to default if not available
    const domain = debriefSurvey?.organization_info?.employee_id_domain || 'staples@innerlogic.datastruk.com';
    const employeeEmail = `${email}.${domain}`;

    dispatch({
      type: SG_VERIFY_EMPLOYEE_SURVEY,
      payload: {
        email: employeeEmail,
        survey_id: token,
      },
    });
  }

  useEffect(() => {
    setSubmitError(get_errors?.errors?.data?.message?.message)
  },[get_errors])

  useEffect(() => {
    const ErrorList = {};
    let totalErrors = 0;

    if (!pristine) {
      if (email?.length === 0) {
        ErrorList["email"] = {
          error: true,
          message: language == "EN" ? "Please enter your 7-digit associate ID" : "Veuillez entrer votre identifiant d'associé à 7 chiffres",
        };
        totalErrors += 1;
      } else if (!ValidateAssociateID(email)) {
        ErrorList["email"] = {
          error: true,
          message: language == 'EN' ? "Please enter a valid 7-digit associate ID" : "Veuillez entrer un identifiant d'associé valide à 7 chiffres",
        };
        totalErrors += 1;
      } else if (get_errors?.errors) {
        // Handle any API errors
        const status = get_errors.errors.status;
        const apiMessage = get_errors.errors.data?.message?.message || get_errors.errors.data?.detail;
        
        if (status === 403) {
          ErrorList["email"] = {
            error: true,
            message: language == "EN" 
              ? 'This survey for this associate ID has been completed.'
              : 'Ce sondage pour cet identifiant d\'associé a été complété.',
          };
          totalErrors += 1;
        } else if (apiMessage) {
          ErrorList["email"] = {
            error: true,
            message: language == "EN" 
              ? (apiMessage || 'This associate ID has already been used. Please use a different associate ID.')
              : (apiMessage || "Cet identifiant d'associé a déjà été utilisé. Veuillez utiliser un identifiant d'associé différent."),
          };
          totalErrors += 1;
        }
      }
    }
    
    ErrorList["errors"] = totalErrors;
    setFormErrors(ErrorList);
  }, [email, pristine, get_errors, language]);

  const inputRefs = [
    React.useRef(null),
    React.useRef(null),
    React.useRef(null),
    React.useRef(null),
    React.useRef(null),
    React.useRef(null),
    React.useRef(null),
  ];

  const handleDigitChange = (index, value) => {
    // Only allow digits
    if (value && !/^\d$/.test(value)) return;

    const newDigits = email.split('');
    newDigits[index] = value;
    const newEmail = newDigits.join('').slice(0, 7);
    setEmail(newEmail);
    setFetchedSurveyUrl(null);
    
    // Clear errors when user starts typing
    if (formErrors?.email?.error) {
      setFormErrors({ email: { error: false, message: "" }, errors: 0 });
    }

    // Auto-focus next input
    if (value && index < 6 && inputRefs[index + 1].current) {
      inputRefs[index + 1].current.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !email[index] && index > 0 && inputRefs[index - 1].current) {
      inputRefs[index - 1].current.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 7);
    setEmail(pastedData);
    setFetchedSurveyUrl(null);
    
    // Focus the next empty input or the last one
    const nextIndex = Math.min(pastedData.length, 6);
    if (inputRefs[nextIndex].current) {
      inputRefs[nextIndex].current.focus();
    }
  };

  return (
    <TransitionGroup>
      <CSSTransition
        key={token}
        classNames={direction}
        timeout={{ enter: 500, exit: 500 }}
        onEntered={() => setIsVisible(true)}
        onExited={() => setIsVisible(false)}
      >
        <div>
          <InnerlogicLogoImgTop src={InnerlogicLogo} alt="Innerlogic" />
          <ModuleContainer className="module-wrapper">
          <Form>


            <LogoContainer>
              <StaplesLogo src="https://firebasestorage.googleapis.com/v0/b/charactercode-a247a.appspot.com/o/email%2FStaples%20email%207.png?alt=media&token=1b48ded5-f6ad-431a-abe3-d61101a1c916" alt="Staples Canada" />
            </LogoContainer>

            <BilingualSection>
              <H1>Welcome to Staples' associate engagement survey, hosted by Innerlogic. Enter your 7-digit associate ID to access the survey.</H1>
              <H1French>Bienvenue au sondage sur l’engagement de l’associé de Staples/Bureau en Gros, hébergé par Innerlogic. Entrez votre identifiant d'associé à 7 chiffres pour accéder au sondage.</H1French>
            </BilingualSection>

            <div style={{width:'100%',display:'flex',justifyContent:'center'}}>
              <Row>
                <DigitInputContainer>
                  {[0, 1, 2, 3, 4, 5, 6].map((index) => (
                    <DigitInput
                      key={index}
                      ref={inputRefs[index]}
                      type="text"
                      inputMode="numeric"
                      maxLength={1}
                      value={email[index] || ''}
                      onChange={(e) => handleDigitChange(index, e.target.value)}
                      onKeyDown={(e) => handleKeyDown(index, e)}
                      onPaste={index === 0 ? handlePaste : undefined}
                    />
                  ))}
                </DigitInputContainer>
                {email.length > 0 && (
                  <ClearLink onClick={() => {
                    setEmail('');
                    setFormErrors({});
                    setPristine(true);
                    setFetchedSurveyUrl(null);
                    // Focus first input after clearing
                    if (inputRefs[0].current) {
                      inputRefs[0].current.focus();
                    }
                  }}>
                    Clear
                  </ClearLink>
                )}
                {!pristine && formErrors?.email?.error && (
                  <ErrorMessage>{formErrors.email.message}</ErrorMessage>
                )}
                <ButtonContainer>
                  {isMobile ? (
                    fetchedSurveyUrl ? (
                      <Button
                        type="button"
                        disabled={!fetchedSurveyUrl}
                        onClick={(e) => {
                          e.preventDefault();
                          const opened = window.open(fetchedSurveyUrl, '_blank');
                          if (!opened) {
                            window.location.assign(fetchedSurveyUrl);
                          }
                          // Reset to clean state
                          setEmail('');
                          setPristine(true);
                          setFormErrors({});
                          setFetchedSurveyUrl(null);
                        }}
                      >
                        {selectedLanguage === 'FR' ? 'Ouvrir le lien' : 'Open link'}
                      </Button>
                    ) : (
                      <>
                        <Button 
                          type="submit" 
                          disabled={verify_pending}
                          onClick={(e) => { 
                            e.preventDefault();
                            setLanguage('EN'); 
                            setSelectedLanguage('EN');
                            handleSubmit(); 
                          }}
                        >
                          {verify_pending ? (
                            <>
                              <Loader active inline size="small" style={{ marginRight: '8px' }} />
                              Getting link...
                            </>
                          ) : (
                            'Get my link'
                          )}
                        </Button>
                        <Button 
                          type="submit" 
                          disabled={verify_pending}
                          onClick={(e) => { 
                            e.preventDefault();
                            setLanguage('FR'); 
                            setSelectedLanguage('FR');
                            handleSubmit(); 
                          }}
                        >
                          {verify_pending ? (
                            <>
                              <Loader active inline size="small" style={{ marginRight: '8px' }} />
                              Obtention du lien...
                            </>
                          ) : (
                            'Obtenir mon lien'
                          )}
                        </Button>
                      </>
                    )
                  ) : (
                    <>
                      <Button 
                        type="submit" 
                        disabled={verify_pending}
                        onClick={(e) => { 
                          e.preventDefault();
                          setLanguage('EN'); 
                          setSelectedLanguage('EN');
                          handleSubmit(); 
                        }}
                      >
                        {verify_pending ? (
                          <>
                            <Loader active inline size="small" style={{ marginRight: '8px' }} />
                            Loading...
                          </>
                        ) : (
                          'Begin survey'
                        )}
                      </Button>
                      <Button 
                        type="submit" 
                        disabled={verify_pending}
                        onClick={(e) => { 
                          e.preventDefault();
                          setLanguage('FR'); 
                          setSelectedLanguage('FR');
                          handleSubmit(); 
                        }}
                      >
                        {verify_pending ? (
                          <>
                            <Loader active inline size="small" style={{ marginRight: '8px' }} />
                            Chargement...
                          </>
                        ) : (
                          'Commencer le sondage'
                        )}
                      </Button>
                    </>
                  )}
                </ButtonContainer>
              </Row>
            </div>
            
          </Form>
        </ModuleContainer>
        </div>
      </CSSTransition>
    </TransitionGroup>
  );
};

export default SurveyStart;

export const ValidateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const ValidateAssociateID = (id) => {
  // Must be exactly 7 digits
  return /^\d{7}$/.test(String(id).trim());
};

// Keyframe animations
const cardIn = keyframes`
  0% { opacity: 0; transform: translateY(12px) scale(0.98); }
  100% { opacity: 1; transform: translateY(0) scale(1); }
`;

const fadeUp = keyframes`
  0% { opacity: 0; transform: translateY(8px); }
  100% { opacity: 1; transform: translateY(0); }
`;

const logoIn = keyframes`
  0% { opacity: 0; transform: translateY(-6px); }
  100% { opacity: 1; transform: translateY(0); }
`;

const BilingualSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding-bottom: 20px;
  border-bottom: 1px solid #e5e7eb;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;

  @media(max-width: 768px) {
    flex-direction: column;
    gap: 10px;
  }
`;

const ErrorMessage = styled.div`
  color: #dc2626;
  font-size: 13px;
  margin-top: -8px;
  margin-bottom: 8px;
  font-family: 'Raleway', sans-serif;
  animation: ${fadeUp} 300ms ease both;
`;

const ModuleContainer = styled.div`
  position: relative;
  min-height: 100vh;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  max-width: 100vw;
  padding: 24px 16px;
  background: linear-gradient(180deg, #f7f9ff 0%, #eef3ff 100%);
`;

const LogoContainer = styled.div`
  display: flex;
  font-family: 'Raleway', sans-serif;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 0px;
  margin-top:0px;
  gap: 16px;
`;

const LogoDivider = styled.span`
  font-size: 24px;
  color: #d1d5db;
  font-weight: 300;
`;

const StaplesLogo = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
  animation: ${logoIn} 500ms ease both;
`;

const InnerlogicLogoImg = styled.img`
  height: 35px;
  animation: ${logoIn} 500ms ease both;
  animation-delay: 100ms;
  opacity: 0;
  animation-fill-mode: forwards;

  @media(max-width: 768px) {
    height: 30px;
  }
`

const InnerlogicLogoImgTop = styled.img`
  position: fixed;
  top: 24px;
  left: 24px;
  height: 35px;
  animation: ${logoIn} 500ms ease both;
  animation-delay: 100ms;
  opacity: 0;
  animation-fill-mode: forwards;
  z-index: 9999;

  @media(max-width: 768px) {
    height: 30px;
    top: 16px;
    left: 16px;
  }
`



const Content = styled.div`
    max-width: 600px;
    width: 100%;
    padding: 40px;
    border-radius:20px;
    background-color: #F8FAFF;
    font-size:28px;
    line-height: 1.5;
    font-weight:500;
    color:#2A3039;
    font-family: 'Raleway', sans-serif;

    @media(max-width:768px){
        font-size:24px;
    }
`

const Image = styled.img`
  width: 100px;
  display: inline;
  vertical-align: middle;
  margin-left: 0.25em;
  margin-right: 0.25em;

    @media(max-width:768px){
        width: 50px;
    }
`;

const Blue = styled.span`
    color: #2d70e2;
    font-weight:700;
`

const Form = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  padding: 32px;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  border: 1px solid #eef2ff;
  max-width: 500px;
  width: 100%;
  animation: ${cardIn} 600ms ease both;
  gap: 20px;

  @media(max-width: 768px) {
    padding: 24px 20px;
  }
`;

const H1 = styled.h1`
  font-size: 1.15rem;
  margin: 0;
  line-height: 1.5;
  color: #1f2937;
  font-weight: 500;
  font-family: 'Raleway', sans-serif;
  margin-bottom: 10px;

  @media(max-width: 768px) {
    font-size: 1.05rem;
  }
`;

const H1French = styled.h1`
  font-size: 1.15rem;
  margin: 0;
  line-height: 1.5;
  color: #1f2937;
  font-weight: 500;
  font-family: 'Raleway', sans-serif;
  margin-bottom: 20px;

  @media(max-width: 768px) {
    font-size: 1.05rem;
  }
`;

const DigitInputContainer = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-bottom: 12px;
  width: 100%;

  @media(max-width: 768px) {
    gap: 6px;
  }
`;

const ClearLink = styled.div`
  color: #6b7280;
  font-size: 12px;
  cursor: pointer;
  text-align: right;
  margin-top: -8px;
  margin-bottom: 8px;
  font-family: 'Raleway', sans-serif;
  transition: color 160ms ease;
  
  &:hover {
    color: #374151;
  }
  
  @media(max-width: 768px) {
    font-size: 11px;
  }
`;

const DigitInput = styled.input`
  width: 48px;
  height: 56px;
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  border: 2px solid #d9e2ff;
  border-radius: 10px;
  font-family: 'Raleway', sans-serif;
  background: #f9fbff;
  transition: border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;
  caret-color: #2254AA;

  &:hover { 
    border-color: #c8d6ff; 
  }

  &:focus {
    outline: none;
    border-color: #2254AA;
    background: #ffffff;
    box-shadow: 0 0 0 3px rgba(34, 84, 170, 0.15);
  }

  @media(max-width: 768px) {
    width: 40px;
    height: 52px;
    font-size: 20px;
  }
`;

const Button = styled.button`
  background-color: #2D70E2;
  border: none;
  color: white;
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 5px;
  cursor: pointer;
  border-radius: 8px;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  min-width: 140px;
  font-family: 'Raleway', sans-serif;
  flex: 1;
  transition: opacity 200ms ease;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  @media(max-width: 768px) {
    width: 100%;
  }
`

const Row = styled.div`
display:flex;
flex-direction:column;
width: 100%;
max-width: 420px;
gap: 8px;

  @media(max-width:768px){
    padding-bottom: 24px;
    width:100%;
  }

`